/*
 * Angular bootstraping
 */
import { platformBrowser } from '@angular/platform-browser';
import { decorateModuleRef } from './app/environment';
import { enableProdMode } from '@angular/core';
/*
 * App Module
 * our top level module that holds all of our components
 */
import { AppModuleNgFactory } from './app/app.module.ngfactory';

if (process.env.ENV === 'production') {
  enableProdMode();
}



/*
 * Bootstrap our Angular app with a top level NgModule
 */
/*export function main(): Promise<any> {
  return platformBrowser()
    .bootstrapModuleFactory(AppModuleNgFactory)
    .then(decorateModuleRef)
    .catch((err) => console.error(err));
}

export function bootstrapDomReady() {
  document.addEventListener('DOMContentLoaded', main);
}

bootstrapDomReady();*/
platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);
